<template>
  <div>
    <!-- <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
           <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <CForm>
        <CRow>
          <!-- <CCol sm="3">
            <CInput disabled label="Issue Code" invalid-feedback="Issue Code should be filled" required v-model="$v.notificationForm.issue_code.$model" :is-valid="!$v.notificationForm.issue_code.$invalid"/>
          </CCol> -->
          
          <CCol sm="3">
            <div class="form-group">
              <label for="user">User</label>
              <model-select
                class="form-control"
                id="user"
                :options="userList"
                v-model="$v.notificationForm.user_code.$model"
                :isError="$v.notificationForm.user_code.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.notificationForm.user_code.$invalid"
                class="invalid-feedback-custom"
              >User should be filled.</div>
            </div>
          </CCol> 
          
          <CCol sm="3">
            <div class="form-group">
              <label for="icon">Type</label>
              <model-select
                class="form-control"
                id="icon"
                :options="typeList"
                v-model="$v.notificationForm.notification_type.$model"
                :isError="$v.notificationForm.notification_type.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.notificationForm.notification_type.$invalid"
                class="invalid-feedback-custom"
              >Icon should be filled.</div>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CInput label="Title" invalid-feedback="Title should be filled" required v-model="$v.notificationForm.title.$model" :is-valid="!$v.notificationForm.title.$invalid"/>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="8">
            <label for="nik">Message</label>
            <quill-editor style="height: 200px; margin-bottom:70px;"
              :content="content"
              :options="editorOption"
              v-model="$v.notificationForm.messages.$model"
              @change="onEditorChange($event)">
            </quill-editor>
            <div v-if="$v.notificationForm.messages.$invalid" class="invalid-feedback-custom">
              Messages harus di isi.
            </div>
            <!-- <CTextarea required rows="4" label="Messages" invalid-feedback="Messages should be filled" v-model="$v.notificationForm.messages.$model" :is-valid="!$v.notificationForm.messages.$invalid"/> -->
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.notificationForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "Notification",
  components: { VueCtkDateTimePicker, quillEditor, Loading, JqxGrid, TableButton },
  data() {
    return {
      title: "Notifikasi",
      userList: [],
      typeList: [],
      content: '',editorOption: {},	// data quill

      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "user_name", type: "string" },
          { name: "title", type: "string" },
          { name: "messages", type: "string" },
          { name: "read_text", type: "string"},
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "user_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama User",
        },
        {
          datafield: "title",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Judul",
        },
        {
          datafield: "messages",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Pesan",
        },
        {
          datafield: "read_text",
          filtertype: "date",
          text: "Tanggal",
          cellsformat:"d"
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        }
      ],

      listBoxSource: [
        {
          label: "Pesan",
          value: "messages",
          checked: true,
        },
        {
          label: "Tanggal",
          value: "read_text",
          checked: true,
        },
      ],

      items: null,
      notificationForm: tableInterfaces.notification,
      isLoading: false,
      addButton: false,
      isEdit: false,
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    notificationForm: {
      user_code : {required},
      title : {required},
      messages : {required},
      notification_type : {},
      read : {},
      date_inserted : {},
      time_read : {},
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function() {
      this.isEdit = false;
      this.cancelForm();
      this.getDropdown();
      this.getNotification();
    },
    getNotification: function() {
      this.isLoading = true;
      this.axios.get("console/notification/listing").then(response => {
        if (response.data.status === 2000) {
          //this.items = response.data.data;
          const temp = this.source;
          temp.localdata = response.data.data;
          this.items = new jqx.dataAdapter(temp);

          // console.log(response.data.data)

          this.showInfoNotification({
            title: this.title,
            message: response.data.message
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message
          });
        }
      })
      .catch(error => {
        this.showErrorNotification({
          title: this.title,
          message: error
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    getDropdown: function() {
      this.axios.get("/console/notification/dropdown").then(response => {
        this.userList = response.data.users;
        this.typeList = response.data.type;
      });
    },
    addForm: function() {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function() {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function(item) {
      this.addForm();
      this.isEdit = true;
      this.notificationForm = item;
    },
    resetForm: function() {
      for (var i in tableInterfaces.notification) {
        tableInterfaces.notification[i] = null;
      }
      this.notificationForm = tableInterfaces.notification;
    },
    submitForm: function(event) {
      event.preventDefault();
      if (confirm("Do you want to add this data ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios.post("console/notification/add", this.notificationForm).then(response => {
          if (response.data.status === 2000) {
            this.showInfoNotification({
              title: this.title,
              message: response.data.message
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message
            });
          }
          this.$router.push({ path: path[2]+"/detail/" + response.data.id });
        }).catch(error => {
          this.showErrorNotification({
            title: this.title,
            message: error
          });
        }).finally(() => {
          this.isLoading = false;
          this.init();
        });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.notificationForm.message = html
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>